/********************* MULTICART VARIABLES *********************/
window.multiCart = localStorage.getItem('_csb-ch-state') ? JSON.parse(localStorage.getItem('_csb-ch-state')) : {};
window.cartJson = document.getElementById('cart_json') ? JSON.parse(document.getElementById('cart_json').innerHTML) : null;
window.cartSettings = document.getElementById('cart_settings') ? JSON.parse(document.getElementById('cart_settings').innerHTML) : null;
window.customerAddresses = document.getElementById('customer_addresses') ? JSON.parse(document.getElementById('customer_addresses').innerHTML) : [];
window.cartAddresses = localStorage.getItem('_csb-ch-addresses') ? JSON.parse(localStorage.getItem('_csb-ch-addresses')) : [];
const urlParams = new URLSearchParams(window.location.search);
window.shippingStep = urlParams.has('view') && urlParams.get('view') === 'shipping-step' ? true : false;
window.noMultiCart = !urlParams.has('view') || (urlParams.has('view') && urlParams.get('view') !== 'multishipping' && urlParams.get('view') !== 'shipping-step') ? true : false;
window.cartItemSettings = document.getElementById('cart_item_settings') ? JSON.parse(document.getElementById('cart_item_settings').innerHTML) : []; 
/********************* END MULTICART VARIABLES *********************/


/********************* VALIDATE PHONE NUMBER *********************/
window.validatePhoneNumber = (phoneInput) => {
  const parent = phoneInput.closest('.address-select')
  const addressTrigger = parent?.querySelector('.select-selected');
  const addressForm = parent?.querySelector('.form--edit');
  const phoneNumber = phoneInput.value.trim();
  const formErrorEl = phoneInput.closest('.form-control')?.querySelector('.error-message');
  const errorMessage = document.createElement('div');
  errorMessage.classList.add('error-message');
  let phoneError = false;
  
  phoneInput.classList.remove('error-input');
  if (formErrorEl) formErrorEl.remove();

  if (!phoneNumber) {
    errorMessage.innerText = 'This field is required';
    phoneError = true;
  } else if (phoneNumber.length < 8) {
    errorMessage.innerText = 'Invalid phone number';
    phoneError = true;
  }

  if (phoneError) {
    phoneInput.classList.add('error-input');
    phoneInput.parentNode.appendChild(errorMessage);

    if (addressTrigger) addressTrigger.classList.add('is-active');
    if (addressForm) addressForm.style.display = "block";
    return false;
  }

  return true;
}
/********************* END VALIDATE PHONE NUMBER *********************/


const syncZipRequirement = (form) => {
  const country = form.querySelector('[name="address[country]"]');
  const zip = form.querySelector('[name="address[zip]"]');
  if (!country || !zip) return;

  const isRequired = window.isZipRequired(country.value);
  const label = zip.closest('.form-control')?.querySelector('.floating-label');
  zip.required = isRequired;

  if (label) {
    if (!label.dataset.requiredLabel) label.dataset.requiredLabel = label.textContent.trim();
    label.textContent = isRequired ? label.dataset.requiredLabel : `${label.dataset.requiredLabel.replace(/\s*\*$/, '')} (optional)`;
  }

  if (!isRequired) {
    zip.classList.remove('error-input');
    zip.parentNode.querySelector('.error-message')?.remove();
  }
}

// Capture phase: country-selector dispatches a non-bubbling change on init
document.addEventListener('change', (e) => {
  if (e.target.matches?.('.cart-address-form [name="address[country]"]')) {
    syncZipRequirement(e.target.closest('.cart-address-form'));
  }
}, true);

document.addEventListener('reset', (e) => {
  if (e.target.matches?.('.cart-address-form')) {
    setTimeout(() => syncZipRequirement(e.target), 0);
  }
}, true);

window.setCountryCodes()
  .catch((error) => console.warn('Could not load countries:', error))
  .then(() => document.querySelectorAll('.cart-address-form').forEach(syncZipRequirement));


/********************* UPDATE ATTRIBUTE ADDRESS *********************/
window.updateAttributeAddres = async (object, currentShopiAddress = null) => {
  await fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ attributes: {
      _preSelectedAddress: {
        firstname: object.firstname || "",
        lastname: object.lastname || "",
        company: object.company || "",
        address1: object.address1 || "",
        address2: object.address2 || "",
        zip: object.zip || "",
        city: object.city || "",
        state: currentShopiAddress?.province_code || object?.state || "",
        state_full: currentShopiAddress?.province || object?.state_full || "",
        country: object.country || "",
        countryCode: window.getCountryCodeByName([object.country]) || "",
        phone: object.phone || "",
        full: window.formatAddress(object, true) || ""
      }
    }})
  });
}
/********************* END UPDATE ATTRIBUTE ADDRESS *********************/


/********************* ADDRESS SELECT *********************/
function escapeHTMLAttr(str) {
  return str.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/`/g, '&#96;')
            .replace(/\n/g, '&#10;');
}
class addressSelect extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.initSelect(this);

    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('custom:address-select-init'));
      this.select.classList.add('inited');
    }, 0);
  }

  initSelect(event, localStorage = true) {
    
    if (event) {
      const marketLogic = window.cartSettings.market_logic_status && window.cartSettings.hide_unavailable_market_addresses ? true : false;
      let container, i, optionsLength, selectElement, selectedDiv, optionsList, addressSearch, optionItem, foundItem;
      let itemKey = event.closest('[data-item-key]')?.getAttribute('data-item-key').split(',')[0];
      container = event;
      selectElement = event.querySelector("select");
      const billingAddress = event.classList.contains('address-select--billing') ? true : false;

      if (selectElement) {
        let addresses = window.cartAddresses || [];
        window.customerAddresses = document.getElementById('customer_addresses') ? JSON.parse(document.getElementById('customer_addresses').innerHTML) : [];

        if (window.shippingStep && window.customerAddresses.length && !billingAddress) {
          const custAddrs = window.customerAddresses.map(item => {
            return {
              ...item,
              firstname: item.first_name || "",
              lastname: item.last_name || "",
              state: item.province_code || "",
              // Remove the old keys
              first_name: undefined,
              last_name: undefined,
              province_code: undefined,
            };
          });

          addresses = [...custAddrs, ...addresses];
        }

        if (window.shippingStep && window.multiCart?.groups && window.multiCart.groups.length) {
          window.multiCart.groups.forEach((group) => {
            if (group.address && group.address.address1) {
              const existingAddress = addresses.find(addr => 
                addr.address1 === group.address.address1 && 
                (addr.zip || "") === (group.address.zip || "") &&
                addr.country === group.address.country
              );
              
              if (!existingAddress) {
                addresses.push({...group.address});
              }
            }
          });
        }

        if (!window.shippingStep && window.csbGetCookie("customerService") && window.cartSettings.customer_email) {
          addresses = [];
        }

        addresses.forEach((object) => {
          const addressFull = window.formatAddress(object, true);
          const existingOption = addressFull ? selectElement.querySelector(`option[data-address-full="${escapeHTMLAttr(addressFull)}"]`) : null;
          const existionCustomerOption = Array.from(selectElement.options).find(item => item?.attributes['data-address-full']?.value && item?.attributes['data-address-full']?.value === addressFull);
          let marketAddressHideStatus = false;

          if (marketLogic && ((window.cartSettings.localization === "united-kingdom" && object.country.trim().toLowerCase() !== "united kingdom") || (window.cartSettings.localization !== "united-kingdom") && object.country.trim().toLowerCase() === "united kingdom")) {
            marketAddressHideStatus = true;
          }
          
          if (!existingOption && !existionCustomerOption && !marketAddressHideStatus) {
            selectElement.insertAdjacentHTML('beforeend',
              `<option value='${object ? escapeHTMLAttr(window.formatAddress(object)) : ""}'
              data-address-firstname="${object.firstname ? object.firstname : ""}"
              data-address-lastname="${object.lastname ? object.lastname : ""}"
              data-address-company="${object.company ? object.company : ""}"
              data-address-address1="${object.address1 ? object.address1 : ""}"
              data-address-address2="${object.address2 ? object.address2 : ""}"
              data-address-city="${object.city}"
              data-address-province="${object.state || ""}"
              data-address-province-full="${object.province || object.state_full || ""}"
              data-address-zip="${object.zip || ""}"
              data-address-country="${object.country}"
              data-address-phone="${object.phone}"
              data-address-validation="${object.validation_status ? "Valid" : ""}"
              data-address-full="${addressFull ? addressFull : ""}"
              data-address-id="${object.id || ""}">${escapeHTMLAttr(window.formatAddress(object))}</option>`
            );
          } else if (existingOption) {
            existingOption.classList.add('is-hidden');
          }
        })

        optionsLength = selectElement.options.length;
        selectedDiv = document.createElement("DIV");
        selectedDiv.setAttribute("class", `select-selected${window.cartSettings?.address_edit && window.cartSettings.address_edit === 'edit' && window.shippingStep && !billingAddress ? ' address-edit' : ''}`);

        if (window.shippingStep && !billingAddress) {
          const groupDiv = event.closest('.shipping-section__delivery-group');
          const groupIndex = groupDiv ? parseInt(groupDiv.getAttribute('data-delivery-index')) : -1;
          
          if (groupIndex >= 0 && window.multiCart?.groups && window.multiCart.groups[groupIndex]) {
            const group = window.multiCart.groups[groupIndex];
            
            if (group.address && group.address.address1) {
              const addressFull = group.address.full || window.formatAddress(group.address, true);
              
              let foundOption = false;
              Array.from(selectElement.options).forEach((option) => {
                if (option.getAttribute('data-address-full') === addressFull) {
                  option.setAttribute('selected', 'selected');
                  foundOption = true;
                }
              });
              
              if (!foundOption) {
                const newOption = document.createElement('option');
                newOption.value = window.formatAddress(group.address);
                newOption.setAttribute('data-address-firstname', group.address.firstname || "");
                newOption.setAttribute('data-address-lastname', group.address.lastname || "");
                newOption.setAttribute('data-address-company', group.address.company || "");
                newOption.setAttribute('data-address-address1', group.address.address1 || "");
                newOption.setAttribute('data-address-address2', group.address.address2 || "");
                newOption.setAttribute('data-address-city', group.address.city || "");
                newOption.setAttribute('data-address-province', group.address.state || "");
                newOption.setAttribute('data-address-province-full', group.address.state_full || "");
                newOption.setAttribute('data-address-zip', group.address.zip || "");
                newOption.setAttribute('data-address-country', group.address.country || "");
                newOption.setAttribute('data-address-phone', group.address.phone || "");
                newOption.setAttribute('data-address-validation', group.address.validation_status ? "Valid" : "");
                newOption.setAttribute('data-address-full', addressFull);
                newOption.setAttribute('data-address-id', group.address.id || "");
                newOption.textContent = addressFull;
                newOption.setAttribute('selected', 'selected');
                selectElement.appendChild(newOption);
              }
            }
          }
        } else if (window.multiCart && window.multiCart?.carts?.length && itemKey) {
          foundItem = window.multiCart.carts.find(item => item.item_id === itemKey);

          if (!foundItem && window.csbGetCookie('old_backorder_key')) {
            itemKey = window.csbGetCookie('old_backorder_key');
            foundItem = window.multiCart.carts.find(item => item.item_id === itemKey);
          }

          if (!foundItem && window.cartJson.items.length === window.multiCart.carts.length) {
            const itemIndex = event.closest('[data-line-item-index]')?.getAttribute('data-line-item-index');
            
            if (itemIndex) {
              const reversedCarts = [...window.multiCart.carts].reverse();
              const potentialItem = reversedCarts[itemIndex];
              const cartJsonItem = window.cartJson.items[itemIndex];

              if (potentialItem && cartJsonItem && 
                  potentialItem.item.product_title === cartJsonItem.product_title &&
                  potentialItem.item.variant_id === cartJsonItem.variant_id) {
                foundItem = potentialItem;
                foundItem.item_id = itemKey;
                foundItem.item.key = itemKey;
              }
            }
          }
          
          Array.from(selectElement.options).forEach((option) => {
            if ((foundItem?.formattedAddress && option.getAttribute('data-address-full') === foundItem.address.full) || (foundItem?.address?.id && option.getAttribute('data-address-id') === foundItem.address.id)) {
              option.setAttribute('selected', 'selected');
            }
          });
        } else if (window.noMultiCart && window.cartJson && window.cartJson.attributes?._preSelectedAddress) {
          let addressAttr = window.cartJson.attributes?._preSelectedAddress;

          if (typeof addressAttr === 'string') {
            addressAttr = JSON.parse(addressAttr.replace(/=>/g, ':'));
          }
          
          Array.from(selectElement.options).forEach((option) => {
            if (option.getAttribute('data-address-full') === addressAttr.full) {
              option.setAttribute('selected', 'selected');
            }
          });
        }
        
        const defaultPlaceholder = billingAddress ? "Please choose a billing address" : "Please choose a shipping address";
        selectedDiv.innerHTML = selectElement.options[selectElement.selectedIndex]?.value ? selectElement.options[selectElement.selectedIndex].value : defaultPlaceholder;
        container.appendChild(selectedDiv);

        addressSearch = document.createElement("div");
        addressSearch.setAttribute("class", "select-search search-hide");
        if (optionsLength <= 20) addressSearch.classList.add('is-hidden');
        addressSearch.setAttribute("autocomplete", "off");
        addressSearch.innerHTML = `<input type="text" name="address_search" placeholder="Search"><svg class="select-search__clear is-hidden" width="25" height="26" viewBox="0 0 25 26" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.3953 13L4.91564 6.52189C4.843 6.44925 4.78538 6.36301 4.74607 6.26811C4.70676 6.1732 4.68652 6.07149 4.68652 5.96876C4.68652 5.86604 4.70676 5.76432 4.74607 5.66941C4.78538 5.57451 4.843 5.48827 4.91564 5.41564C4.98827 5.343 5.07451 5.28538 5.16941 5.24607C5.26432 5.20676 5.36604 5.18652 5.46876 5.18652C5.57149 5.18652 5.6732 5.20676 5.76811 5.24607C5.86301 5.28538 5.94925 5.343 6.02189 5.41564L12.5 11.8953L18.9781 5.41564C19.1248 5.26894 19.3238 5.18652 19.5313 5.18652C19.7387 5.18652 19.9377 5.26894 20.0844 5.41564C20.2311 5.56233 20.3135 5.7613 20.3135 5.96876C20.3135 6.17622 20.2311 6.37519 20.0844 6.52189L13.6047 13L20.0844 19.4781C20.2311 19.6248 20.3135 19.8238 20.3135 20.0313C20.3135 20.2387 20.2311 20.4377 20.0844 20.5844C19.9377 20.7311 19.7387 20.8135 19.5313 20.8135C19.3238 20.8135 19.1248 20.7311 18.9781 20.5844L12.5 14.1047L6.02189 20.5844C5.87519 20.7311 5.67622 20.8135 5.46876 20.8135C5.2613 20.8135 5.06233 20.7311 4.91564 20.5844C4.76894 20.4377 4.68652 20.2387 4.68652 20.0313C4.68652 19.8238 4.76894 19.6248 4.91564 19.4781L11.3953 13Z"></path>
          </svg>`

        optionsList = document.createElement("UL");
        optionsList.setAttribute("class", "select-items select-hide");
        for (i = 0; i < optionsLength; i++) {
          if (selectElement.options[i].value) {
            optionItem = document.createElement("LI");
            optionItem.innerHTML = selectElement.options[i].textContent;

            Array.from(selectElement.options[i].attributes).forEach(attr => {
              if (attr.name.startsWith('data-address')) {
                optionItem.setAttribute(attr.name, attr.value);
              }
            });

            if (optionItem.getAttribute('data-address-full') === selectElement.options[selectElement.selectedIndex]?.getAttribute('data-address-full')) {
              optionItem.classList.add("is-selected");
            }
            optionItem.addEventListener("click", function (e) {
              let k, selectOptions, previousSelected, selectedOptions, selectedOptionsLength;
              selectOptions = this.parentNode.parentNode.getElementsByTagName("select")[0];
              selectedOptionsLength = selectOptions.length;
              previousSelected = this.parentNode.previousSibling.previousSibling;
              for (k = 0; k < selectedOptionsLength; k++) {
                if (selectOptions.options[k].getAttribute('data-address-full') === this.getAttribute('data-address-full')) {
                  selectOptions.selectedIndex = k;
                  previousSelected.innerHTML = this.innerHTML;
                  selectedOptions = this.parentNode.getElementsByClassName("is-selected");
                  selectedOptionsLength = selectedOptions.length;

                  for (let m = 0; m < selectedOptionsLength; m++) {
                    selectedOptions[m].removeAttribute("class");
                  }

                  this.setAttribute("class", "is-selected");
                  const selectSelected = this.closest('address-select').querySelector(".select-selected");
                  selectSelected.classList.add("active-selected");

                  if (selectSelected.classList.contains('is-error')) {
                    selectSelected.classList.remove('is-error')
                  }

                  for (let n = 0; n < selectOptions.options.length; n++) {
                    selectOptions.options[n].removeAttribute("selected");
                  }

                  selectOptions.options[k].setAttribute("selected", "selected");
                  if (window.noMultiCart) {
                    fetch(`${Shopify.routes.root}cart/update.js`, {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({ attributes: {
                        _preSelectedAddress: {
                          firstname: selectOptions.options[k].getAttribute('data-address-firstname') || "",
                          lastname: selectOptions.options[k].getAttribute('data-address-lastname') || "",
                          company: selectOptions.options[k].getAttribute('data-address-company') || "",
                          address1: selectOptions.options[k].getAttribute('data-address-address1') || "",
                          address2: selectOptions.options[k].getAttribute('data-address-address2') || "",
                          zip: selectOptions.options[k].getAttribute('data-address-zip') || "",
                          city: selectOptions.options[k].getAttribute('data-address-city') || "",
                          state: selectOptions.options[k].getAttribute('data-address-province') || "",
                          state_full: selectOptions.options[k].getAttribute('data-address-province-full') || "",
                          country: selectOptions.options[k].getAttribute('data-address-country') || "",
                          countryCode: window.getCountryCodeByName([selectOptions.options[k].getAttribute('data-address-country')]) || "",
                          phone: selectOptions.options[k].getAttribute('data-address-phone') || "",
                          full: selectOptions.options[k].getAttribute('data-address-full') || ""
                        }
                      }})
                    });
                  } else if (billingAddress) {
                    const billingAddressForm = document.querySelector('.cart-billing-address-form');
                    if (billingAddressForm) {
                      const billingCountry = billingAddressForm.querySelector('[name="address[country]"]');
                      const billingFirstName = billingAddressForm.querySelector('[name="address[first_name]"]');
                      const billingLastName = billingAddressForm.querySelector('[name="address[last_name]"]');
                      const billingCompany = billingAddressForm.querySelector('[name="address[company]"]');
                      const billingAddress1 = billingAddressForm.querySelector('[name="address[address1]"]');
                      const billingAddress2 = billingAddressForm.querySelector('[name="address[address2]"]');
                      const billingCity = billingAddressForm.querySelector('[name="address[city]"]');
                      const billingZip = billingAddressForm.querySelector('[name="address[zip]"]');
                      const billingProvince = billingAddressForm.querySelector('[name="address[province]"]');
                      const billingPhone = billingAddressForm.querySelector('[name="address[phone]"]');

                      if (billingFirstName) billingFirstName.value = selectOptions.options[k].getAttribute('data-address-firstname') || "";
                      if (billingLastName) billingLastName.value = selectOptions.options[k].getAttribute('data-address-lastname') || "";
                      if (billingCompany) billingCompany.value = selectOptions.options[k].getAttribute('data-address-company') || "";
                      if (billingAddress1) billingAddress1.value = selectOptions.options[k].getAttribute('data-address-address1') || "";
                      if (billingAddress2) billingAddress2.value = selectOptions.options[k].getAttribute('data-address-address2') || "";
                      if (billingCity) billingCity.value = selectOptions.options[k].getAttribute('data-address-city') || "";
                      if (billingZip) billingZip.value = selectOptions.options[k].getAttribute('data-address-zip') || "";
                      if (billingProvince) billingProvince.value = selectOptions.options[k].getAttribute('data-address-province') || "";
                      if (billingPhone) billingPhone.value = selectOptions.options[k].getAttribute('data-address-phone') || "";

                      setTimeout(() => {
                        if (billingCountry && selectOptions.options[k].hasAttribute('data-address-country')) {
                          const countryName = selectOptions.options[k].getAttribute('data-address-country').toLowerCase().trim();

                          for (let i = 0; i < billingCountry.options.length; i++) {
                            const opt = billingCountry.options[i];
                            if (opt.value.toLowerCase().trim() === countryName || opt.innerHTML.toLowerCase().trim() === countryName) {
                              billingCountry.value = opt.value;
                              break;
                            }
                          }
                          billingCountry.dispatchEvent(new Event('change', { bubbles: true }));

                          if (billingProvince && selectOptions.options[k].hasAttribute('data-address-province')) {
                            const state = selectOptions.options[k].getAttribute('data-address-province-full');
                            if (state) {
                              billingProvince.value = state;
                              billingProvince.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                          }
                        }

                        const billingAddressInputs = billingAddressForm.querySelectorAll('input[required], select[required]');
                        billingAddressForm.querySelectorAll('.error-message')?.forEach(el => el.remove());
                        billingAddressInputs.forEach(input => input.classList.remove('error-input'));
                        
                        billingAddressInputs.forEach(input => {
                          if (!input.value.trim() && !input.hasAttribute('disabled')) {
                            formIsValid = false;
                            input.classList.add('error-input');
                            const errorMessage = document.createElement('div');
                            errorMessage.classList.add('error-message');
                            errorMessage.innerText = 'This field is required';
                            input.parentNode.appendChild(errorMessage);
                          }
                        });
                      }, 0);
                    }
                  } else {
                    window.updateLineItems(window.shippingStep && !billingAddress ? true : false);
                  }
                  break;
                }
              }
              previousSelected.click();
              window.dispatchEvent(new CustomEvent('custom:address-select-init', { detail: selectElement }));
            });
            optionsList.appendChild(optionItem);
          }
        }

        container.appendChild(addressSearch);

        if (window.multiCart && window.multiCart.carts && window.multiCart.carts.length) {
          foundItem = window.multiCart.carts.find(item => item.item_id === itemKey);
        }

        const newAddressItem = document.createElement("LI");
        newAddressItem.setAttribute('data-add-new-address', true);
        newAddressItem.innerHTML = "+ Add Address";
        newAddressItem.addEventListener("click", function (e) {
          const addressPopup = document.querySelector('#new-address-popup');
          const itemKey = event.closest('[data-item-key]')?.getAttribute('data-item-key');
          if (addressPopup) {
            window.showModal('new-address-popup');

            if (itemKey) document.querySelector('[data-item-popup-key]')?.setAttribute('data-item-popup-key', itemKey);
          }
        });
        optionsList.appendChild(newAddressItem);

        container.appendChild(optionsList);

        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('custom:address-select-init', { detail: true }));
        }, 500)

        const noResultsItem = document.createElement("LI");
        noResultsItem.setAttribute('data-no-results', true);
        noResultsItem.style.display = "none";
        noResultsItem.innerHTML = "No results found";
        optionsList.insertBefore(noResultsItem, optionsList.firstChild);

        addressSearch.querySelector('input').addEventListener('input', function() {
          const searchQuery = this.value.toLowerCase();
          let hasResults = false;

          if (searchQuery.length > 0) {
            addressSearch.querySelector('.select-search__clear').classList.remove('is-hidden');
          } else {
            addressSearch.querySelector('.select-search__clear').classList.add('is-hidden');
          }

          Array.from(optionsList.children).forEach(item => {
            if (!item.hasAttribute('data-add-new-address') && !item.hasAttribute('data-no-results')) {
              const addressText = item.innerHTML.toLowerCase();
              const isDatasetIncludesSearchedValue = Object.values(item.dataset).some(i => i.toLowerCase().includes(searchQuery))
              if (addressText.includes(searchQuery) || isDatasetIncludesSearchedValue) {
                item.style.display = "";
                hasResults = true;
              } else {

                item.style.display = "none";
              }
            }
          });

          noResultsItem.style.display = hasResults ? "none" : "";
        });

        addressSearch.querySelector('.select-search__clear').addEventListener('click', function () {
          const searchInput = addressSearch.querySelector('input');
          searchInput.value = "";
          searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        })

        if (window.cartSettings?.address_edit && window.cartSettings.address_edit === 'edit' && window.shippingStep && !billingAddress) {
          const editAddressForm = document.getElementById('edit_form').cloneNode(true);
          editAddressForm.removeAttribute('id');
          container.appendChild(editAddressForm);
          const thisForm = container.querySelector('.form--edit');
          const groupIndex = Number(container.closest('.shipping-section__delivery-group')?.getAttribute('data-delivery-index')) + 1;

          if (thisForm && foundItem) {
            thisForm.setAttribute('data-default-address', foundItem.formattedAddress);
            const formCountrySelector = thisForm.querySelector('country-selector');

            if (foundItem.address.id && foundItem.address.id !== 'undefined') {
              thisForm.setAttribute('data-address-id', foundItem.address.id);
            }

            const country = thisForm.querySelector('[name="address[country]"]');
            const firstname = thisForm.querySelector('[name="address[first_name]"]');
            const lastname = thisForm.querySelector('[name="address[last_name]"]');
            const address1 = thisForm.querySelector('[name="address[address1]"]');
            const address2 = thisForm.querySelector('[name="address[address2]"]');
            const company = thisForm.querySelector('[name="address[company]"]');
            const city = thisForm.querySelector('[name="address[city]"]');
            const zip = thisForm.querySelector('[name="address[zip]"]');
            const phone = thisForm.querySelector('[name="address[phone]"]');
            let state = thisForm.querySelector('[name="address[province]"]');

            if (address1) {
              address1.setAttribute('id', 'address1_' + groupIndex)
              address1.value = foundItem.address.address1;
            }
            if (address2) {
              address2.setAttribute('id', 'address2_' + groupIndex)
              address2.value = foundItem.address.address2;
            }
            if (city) {
              city.setAttribute('id', 'city_' + groupIndex)
              city.value = foundItem.address.city;
            }
            if (zip) {
              zip.setAttribute('id', 'zip_' + groupIndex)
              zip.value = foundItem.address.zip;
            }
            if (firstname) firstname.value = foundItem.address.firstname;
            if (lastname) lastname.value = foundItem.address.lastname;
            if (company) company.value = foundItem.address.company;
            if (phone) phone.value = foundItem.address.phone;

            setTimeout(() => {
              let countryValue;

              for (let i = 0; i < country.options.length; i++) {
                const option = country[i];
                if (option.value.toLowerCase().trim() === foundItem.address.country.toLowerCase().trim() || option.innerHTML.toLowerCase().trim() === foundItem.address.country.toLowerCase().trim()) {
                  countryValue = option.value;
                  break;
                }
              }

              if (countryValue) {
                formCountrySelector.setAttribute('country', countryValue);
                if (state && foundItem?.address?.state_full) formCountrySelector.setAttribute('province', foundItem.address.state_full);

                country.setAttribute('id', 'country_' + groupIndex);
                country.value = countryValue;
                country.dispatchEvent(new Event('change', { bubbles: true }));

                if (state) {
                  state.setAttribute('id', 'state_' + groupIndex)
                  if (foundItem?.address?.state_full) {
                    state.value = foundItem.address.state_full;
                    state.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
              }
            }, 0);
          }
        }

        selectedDiv.addEventListener("click", function (e) {
          e.stopPropagation();

          if (window.cartSettings?.address_edit && window.cartSettings.address_edit === 'edit' && window.shippingStep && !billingAddress) {
            const addressForm = container.querySelector('.form--edit');

            if (addressForm) {
              e.target.classList.add('is-disabled',);
              setInterval(() => {
                e.target.classList.remove('is-disabled')
              }, 200);
              e.target.classList.toggle('is-active');
              window.slideToggleContent(addressForm);
            }
          } else {
            const otherActiveSelect = document.querySelectorAll('.select-arrow-active');
            if (otherActiveSelect.length) {
              otherActiveSelect.forEach(el => {
                if (el !== this) {
                  el.classList.remove('select-arrow-active');
                  el.nextElementSibling?.classList.add('search-hide');
                  el.nextElementSibling?.nextElementSibling?.classList.add('select-hide');
                }
              });
            }
            this.nextSibling.classList.toggle("search-hide");
            this.nextSibling.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
          }
        });
        event.classList.add('inited');
      }
    }

  }

  reinitialize() {
    const selectedDiv = this.querySelector('.select-selected');
    const optionsList = this.querySelector('.select-items');
    const addressForm = this.querySelector('.form--edit');
    
    if (selectedDiv) selectedDiv.remove();
    if (optionsList) optionsList.remove();
    if (addressForm) addressForm.remove();
    
    this.initSelect(this, false);
  }

  _onAddressChange(event) {
    const countElement = this.closest('.cart-form__gift')?.querySelector('.cart-form__gift-header-sizes-current');

    if (countElement) {
      countElement.innerHTML = event.target.value.length;
    } 
  }
};

if (!window.customElements.get("address-select")) {
  window.customElements.define("address-select", addressSelect);
}
/********************* END ADDRESS SELECT *********************/


/********************* ADD NEW ADDRESS *********************/
window.addNewAddress = (address, itemKey, saveToLocalStorage = false, edit = undefined, editGroupIndex, customerAddressId) => {
  const rateLoader = document.querySelectorAll('.shipping-estimator-result-container .loader');
  const selectElements = document.querySelectorAll('address-select:not(.address-select--billing)');
  const object = {};
  let addressTimeout;

  if (edit && rateLoader.length) {
    clearTimeout(addressTimeout);
    addressTimeout = setTimeout(() => {
      window.addNewAddress(address, itemKey, saveToLocalStorage, edit, editGroupIndex);
    }, 1000);
    return;
  }

  itemKey = itemKey?.split(',')[0];

  address.forEach((value, key) => {
    object[key.replace('address[', '').replace(']','').replace('first_name', 'firstname').replace('last_name', 'lastname').replace('province', 'state').replace('province_full', 'state_full')] = value;
  });

  // Ensure address1 and address2 don't exceed 50 characters
  if (object.address1 && object.address1.length > 50) {
    object.address1 = object.address1.substring(0, 50);
  }
  if (object.address2 && object.address2.length > 50) {
    object.address2 = object.address2.substring(0, 50);
  }

  if (object.state) {
    const countryCode = window.getCountryCodeByName(object.country);
    const stateCode = window.getStateCodeByName(countryCode, object.state) !== "Not Found" ? window.getStateCodeByName(countryCode, object.state) : object.state;
    object.state_full = object.state;
    object.state = stateCode;
  }

  const formattedAddress = window.formatAddress(object);
  const formattedAddressWithCompany = window.formatAddress(object, true, true);

  if (selectElements.length) {
    let currentShopiAddress = edit && !saveToLocalStorage ? window.customerAddresses.find((address) => 
        address.address1 === object.address1 && 
        address.address2 === object.address2 && 
        address.company === object.company && 
        address.country === object.country && 
        address.zip === object.zip && 
        address.phone === object.phone && 
        address.first_name === object.firstname && 
        address.last_name === object.lastname) : null;

    if (currentShopiAddress) {
      object.state = currentShopiAddress.province_code || "";
    }

    selectElements.forEach((select) => {
      const itemEl = !window.noMultiCart ? select.closest('[data-item-key]') : null;
      const selectOptions = select.querySelectorAll('option');
      const addressId = customerAddressId || itemEl?.querySelector('.form--edit[data-address-id]')?.getAttribute('data-address-id');

      const newOption = `<option value="${formattedAddress}" 
        data-address-firstname="${object.firstname}"
        data-address-lastname="${object.lastname}"
        data-address-company="${object.company}"
        data-address-address1="${object.address1}"
        data-address-address2="${object.address2}"
        data-address-city="${object.city}"
        data-address-province="${object.state || ""}"
        data-address-province-full="${object.state_full || ""}"
        data-address-zip="${object.zip}"
        data-address-country="${object.country}"
        data-address-phone="${object.phone}"
        data-address-validation="${object.validation_status ? "Valid" : ""}"
        data-address-full="${window.formatAddress(object, true)}"
        data-address-id="${addressId ? addressId : ""}" ${(itemEl && (itemEl.getAttribute('data-item-key').includes(itemKey) || (edit && itemEl.querySelector(`[data-default-address="${CSS.escape(edit)}"]`)))) || window.noMultiCart ? "selected" : ''}>${formattedAddressWithCompany}</option>`;
      let isDuplicate = false;

      if (selectOptions.length) {
        selectOptions.forEach((opt) => {
          if(opt.getAttribute('data-address-full') === window.formatAddress(object, true)) {
            isDuplicate = true;
            if (itemEl && itemEl.getAttribute('data-item-key').includes(itemKey)) {
              opt.setAttribute('selected', 'selected');
            }
          }
        })
      }

      if (edit) {
        const currentSelect = select.querySelector(`option[value="${CSS.escape(edit)}"]`);
        const itemKeys = itemEl.getAttribute('data-item-key').split(',');

        if (itemKeys.length && window.multiCart?.carts.length) {
          itemKeys.forEach(key => {
            const itemIndex = window.multiCart.carts.findIndex(item => item.item_id === key);
            const groupIndex = window.multiCart.groups.findIndex(group => group.items.some(item => item.item_id === key));
            
            const newAddressObject = {
              "firstname": object.firstname || "",
              "lastname": object.lastname || "",
              "company": object.company || "",
              "address1": object.address1 || "",
              "address2": object.address2 || "",
              "zip": object.zip || "",
              "city": object.city || "",
              "state": currentShopiAddress?.province_code || object?.state || "",
              "state_full": currentShopiAddress?.province || object?.state_full || "",
              "country": object.country || "",
              "phone": object.phone || "",
              "validation_status": object.validation_status ? object.validation_status : ""
            }
            window.multiCart.carts[itemIndex].address = newAddressObject;
            window.multiCart.carts[itemIndex].formattedAddress = formattedAddress;
            window.multiCart.groups[groupIndex].address = newAddressObject;
            window.multiCart.groups[groupIndex].formattedAddress = formattedAddress;
          })
        }

        if (currentSelect) {
          if (saveToLocalStorage) {
            currentSelect.insertAdjacentHTML('afterend', newOption);
            currentSelect.remove();
          } else {
            currentSelect.value = formattedAddress;
            currentSelect.innerHTML = formattedAddress;
            currentSelect.setAttribute('data-address-firstname', object.firstname);
            currentSelect.setAttribute('data-address-lastname', object.lastname);
            currentSelect.setAttribute('data-address-company', object.company);
            currentSelect.setAttribute('data-address-address1', object.address1);
            currentSelect.setAttribute('data-address-address2', object.address2);
            currentSelect.setAttribute('data-address-city', object.city);
            currentSelect.setAttribute('data-address-province', object.state || "");
            currentSelect.setAttribute('data-address-province-full', object.state_full || "");
            currentSelect.setAttribute('data-address-zip', object.zip);
            currentSelect.setAttribute('data-address-country', object.country);
            currentSelect.setAttribute('data-address-phone', object.phone);
            currentSelect.setAttribute('data-address-id', addressId ? addressId : "");
            currentSelect.setAttribute('data-address-full', window.formatAddress(object, true));
            currentSelect.setAttribute('data-address-validation', object.validation_status ? object.validation_status : "");

            const currentSelectSelected = itemEl.querySelector('.select-selected.address-edit');
            if (currentSelectSelected && itemEl && itemEl.getAttribute('data-item-key').includes(itemKey) || itemEl.querySelector(`[data-default-address="${CSS.escape(edit)}"]`)) {
              currentSelectSelected.innerHTML = formattedAddress;
              const parent = currentSelect.closest('.address-select');

              if (parent) {
                const form = parent.querySelector('[data-default-address]');
                
                if (form) {
                  const countrySelector = parent.querySelector('country-selector');
                  form.setAttribute('data-default-address', formattedAddress);

                  if (countrySelector) {
                    countrySelector.setAttribute('country', object.country);
                    countrySelector.setAttribute('province', object.state_full || "");
                  }
                } 
              }
            }
          }
        }
      } else if (object.default && !isDuplicate) {
        select.querySelector('.address-select__select').insertAdjacentHTML('afterbegin', newOption);
      } else if (!isDuplicate) {
        select.querySelector('.address-select__select').insertAdjacentHTML('beforeend', newOption);
      }

      if (saveToLocalStorage && window.cartAddresses && !isDuplicate) {
        const addressObject = {
          firstname: object.firstname || "",
          lastname: object.lastname || "",
          company: object.company || "",
          address1: object.address1 || "",
          address2: object.address2 || "",
          zip: object.zip || "",
          city: object.city || "",
          state: currentShopiAddress?.province_code || object?.state || "",
          state_full: currentShopiAddress?.province || object?.state_full || "",
          country: object.country || "",
          phone: object.phone || "",
          validation_status: object.validation_status ? object.validation_status : ""
        }

        if (edit) {
          const existingAddressIndex = window.cartAddresses.findIndex(existingAddress => window.formatAddress(existingAddress) === edit);
          if (existingAddressIndex !== -1) {
            window.cartAddresses[existingAddressIndex] = addressObject;
          }
        } else {
          if (!isDuplicate && itemEl && itemEl.getAttribute('data-item-key').includes(itemKey)) {
            window.cartAddresses.push(addressObject);
          }
        }
      }
        
      if (!edit) {
        select.reinitialize(); 
      }
    })

    if (window.noMultiCart) {
      window.updateAttributeAddres(object, currentShopiAddress);
    } else {
      localStorage.setItem('_csb-ch-addresses', JSON.stringify(window.cartAddresses));
      localStorage.setItem('_csb-ch-state', JSON.stringify(window.multiCart));

      if (edit) {
        setTimeout(() => {
          window.updateLineItems(true, false, false, editGroupIndex);
        }, 0);
      } else {
        window.updateLineItems();
      }
    }
  }
    
  if (!window.shippingStep && (!window.cartSettings?.address_edit || (window.cartSettings?.address_edit && window.cartSettings.address_edit !== 'edit'))) {
    window.hideModal('new-address-popup');
  }
}
/********************* END ADD NEW ADDRESS *********************/


/********************* LOQATE AUTOCOMPLETE *********************/
const loqateMapping = [
  { element: 'address1', field: 'Line1' },
  { element: 'address2', field: 'Line2', mode: pca.fieldMode.POPULATE },
  { element: 'city', field: 'City', mode: pca.fieldMode.POPULATE },
  { element: 'state', field: 'ProvinceName', mode: pca.fieldMode.POPULATE },
  { element: 'zip', field: 'PostalCode', mode: pca.fieldMode.POPULATE },
  { element: 'country', field: 'CountryName', mode: pca.fieldMode.COUNTRY }
],
loqateOptions = { key: window.cartSettings.loqate_key, countries: { codesList: 'USA' }, setCountryByIP: false };

window.initAutocomplete = (billingForm = false) => {
  const addressForms = billingForm ? document.querySelectorAll('.cart-billing-address-form') : document.querySelectorAll('.cart-address-form:not(.cart-billing-address-form)');

  if (window.cartSettings.loqate_key && addressForms.length) {
    for (let i = 0; i < addressForms.length; i++) {
      const mapping = JSON.parse(JSON.stringify(loqateMapping));
      for (let j = 0; j < mapping.length; j++) {
        mapping[j].element += `_${billingForm ? 'bil' : i + 1}`;
      }
      const loqateInstance = new pca.Address(mapping, loqateOptions);
      loqateInstance.listen('show', () => {
        const addressInput = addressForms[i].querySelector('[name="address1"]');
        if (addressInput) {
          addressInput.setAttribute('autocomplete', 'pca-override');
        }
      });
      loqateInstance.listen('hide', () => {
        const addressInput = addressForms[i].querySelector('[name="address1"]');
        if (addressInput) {
          addressInput.removeAttribute('autocomplete');
        }
      });
      loqateInstance.load();
    }
  }
};

if (window.shippingStep) {
  const billingForm = document.querySelector('.cart-billing-address-form');
  if (billingForm) window.initAutocomplete(true);
}
/********************* END LOQATE AUTOCOMPLETE *********************/


/********************* COMPARE ADDRESS *********************/
const compareAddresses = (address1, address2) => {
  return address1.first_name.toLowerCase() === address2.first_name.toLowerCase() 
    && address1.last_name.toLowerCase() === address2.last_name.toLowerCase() 
    && address1.address1.toLowerCase() === address2.address1.toLowerCase()
    && ((!address1.address2 && !address2.address2) || address1.address2.toLowerCase() === address2.address2.toLowerCase())
    && address1.city.toLowerCase() === address2.city.toLowerCase()
    && address1.country.toLowerCase() === address2.country.toLowerCase()
    && (address1.country !== "United States" || (address1.province && address2.province_full && address1.province.toLowerCase() === address2.province_full.toLowerCase()))
    && address1.zip.split('-')[0] === address2.zip.split('-')[0];
}
/********************* END COMPARE ADDRESS *********************/


/********************* LOQATE VALIDATION *********************/
const locateValidation = (thisForm, button, billingAddress = false) => {
  const formData = new FormData(thisForm);
  const defaultAQI = window.cartSettings.loqate_quality_index ? window.cartSettings.loqate_quality_index.split(',').map(item => item.trim()) : [];

  const address = {};
  formData.forEach((value, key) => {
    const match = key.match(/address\[(.*?)\]/);
    if (match) {
      const newKey = match[1]; 

      if (address.hasOwnProperty(newKey)) {
        if (!Array.isArray(address[newKey])) {
          address[newKey] = [address[newKey]];
        }
        address[newKey].push(value);
      } else {
          address[newKey] = value;
      }
    }
  });

  const names = address.first_name + ' ' + address.last_name;

  const params = {
    "Address1": address.address1,
    "Address2": address.address2 || "",
    "Locality": address.city,
    "AdministrativeArea": address.province,
    "PostalCode": address.zip,
    "Country": address.country
  }

  const url = window.cartSettings.loqate_validation_endpoint ? window.cartSettings.loqate_validation_endpoint : 'https://api.addressy.com/Cleansing/International/Batch/v1.00/json4.ws';
  const requestObject = {
    Key: window.cartSettings.loqate_key,
    Geocode: false,
    Addresses: [params]
  };

  fetch(url, {
    method: "POST",
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestObject),
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      sendAddressForm(thisForm, button, billingAddress);
      return;
    }

    if (response[0] && response[0].Input && response[0].Matches) {
      let AQI = response[0].Matches[0]?.AQI;
      
      if (defaultAQI.length && AQI && defaultAQI.includes(AQI)) {
        const vAddresses = response[0].Matches;
        const vAddress = Object.assign({}, address);

        vAddress.address1 = (vAddresses[0].DeliveryAddress1 || "").substring(0, 50);
        vAddress.address2 = (vAddresses[0].DeliveryAddress2 || "").substring(0, 50);
        vAddress.city = vAddresses[0].Locality;
        vAddress.country = window.getCountryNameByCode(vAddresses[0].Country);
        vAddress.province = window.getStateCodeByName(vAddresses[0].Country, vAddresses[0].AdministrativeArea) || "";
        vAddress.province_full = window.getStateCodeByName(vAddresses[0].Country, vAddresses[0].AdministrativeArea, true) || "";
        vAddress.zip = vAddresses[0].PostalCode || "";

        if (address.province && !vAddress.province) {
          vAddress.province = window.getStateCodeByName(vAddresses[0].Country, address.province) || "";
          vAddress.province_full = window.getStateCodeByName(vAddresses[0].Country, address.province, true) || "";
        }

        if (compareAddresses(address,vAddress)) {
          if (thisForm.querySelector('[name="validation_status"]')) thisForm.querySelector('[name="validation_status"]').value = "Valid";
          sendAddressForm(thisForm, button, billingAddress);
        } else {
          const addressPopup = document.querySelector('.address-popup');
          const enteredAddressElement = document.querySelector('#address-popup-customer');
          const fedexAddressElement = document.querySelector('#address-popup-fedex')

          enteredAddressElement.querySelector('p strong').innerHTML = 'Your Entered Address ';
          enteredAddressElement.querySelector('p .address-popup__variant-name').innerHTML = names;
          enteredAddressElement.querySelector('p .address-popup__variant-address').innerHTML = address.address1 + ', ' + address.address2 + ' <br>' + address.city + ', ' + (address.province ? address.province : "") + ' ' + address.zip;
          fedexAddressElement.querySelector('p strong').innerHTML = 'Suggested Address ';
          fedexAddressElement.querySelector('p .address-popup__variant-name').innerHTML = names;
          fedexAddressElement.querySelector('p .address-popup__variant-address').innerHTML = vAddress.address1 + ', ' + vAddress.address2 + ' <br>' + vAddress.city + ', ' + (vAddress.province_full ? vAddress.province_full : "") + ' ' + vAddress.zip;
          addressPopup.classList.add('is-visible');
          document.querySelector('html').classList.add('no-scroll');
          document.querySelector('.address-popup__variant-input[checked]').focus();
          window.showModal('validate-address-popup');

          const popupBtn = document.querySelector('button[data-address-confirm]');
          popupBtn.replaceWith(popupBtn.cloneNode(true));

          setTimeout(function () {
            document.querySelector('button[data-address-confirm]').addEventListener('click', function () {
              if (fedexAddressElement.querySelector('input').checked) {
                vAddress.validation_status = 'Valid';
                thisForm.querySelector('[name="address[address1]"]').value = (vAddress.address1 || "").substring(0, 50);
                thisForm.querySelector('[name="address[address2]"]').value = (vAddress.address2 || "").substring(0, 50);
                thisForm.querySelector('[name="address[city]"]').value = vAddress.city;
                thisForm.querySelector('[name="address[country]"]').value = vAddress.country;
                thisForm.querySelector('[name="address[zip]"]').value = vAddress.zip;
                if (thisForm.querySelector('[name="address[province]"]') && vAddress.province_full) {
                  thisForm.querySelector('[name="address[province]"]').value = vAddress.province_full || "";
                }
              } else if (vAddress.zip && address.zip && vAddress.zip.replaceAll('-','').replaceAll(' ', '') === address.zip.replaceAll('-','').replaceAll(' ', '')) {
                thisForm.querySelector('[name="address[zip]"]').value = vAddress.zip;
              }
              thisForm.querySelector('[name="validation_status"]').value = "Valid";

              window.hideModal('validate-address-popup');
              sendAddressForm(thisForm, button, billingAddress);
            });
          }, 100);
        }
      } else {
        sendAddressForm(thisForm, button, billingAddress);
      }

    } else {
      sendAddressForm(thisForm, button, billingAddress);
      console.log('Request sending error. Try later.')
    }
  })
  .catch((e) => {
    console.error(e);
    sendAddressForm(thisForm, button, billingAddress);
  });
}
/********************* END LOQATE VALIDATION *********************/


/********************* SEND ADDRESS FORM *********************/
// Shopify redirects this POST to the new customer accounts domain, which fetch can't follow cross-origin
const postToCustomerAccount = (url, formData) => {
  return fetch(url, {
    method: 'POST',
    body: formData,
    redirect: 'manual',
  })
  .then((response) => {
    if (response.type === 'opaqueredirect' || response.ok) return;
    throw new Error(`Customer address request failed with status ${response.status}`);
  });
}

const savedAddressFields = {
  first_name: 'firstname',
  last_name: 'lastname',
  company: 'company',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  province: 'province-full',
  zip: 'zip',
  country: 'country',
  phone: 'phone'
};

const savedAddressTimeout = 10000;
const savedAddressMatchFields = ['first_name', 'last_name', 'company', 'address1', 'address2', 'city'];

const isEnteredAddressOption = (option, formData) => savedAddressMatchFields.every((field) => {
  const savedValue = option.getAttribute(`data-address-${savedAddressFields[field]}`) || '';
  const enteredValue = formData.get(`address[${field}]`) || '';
  return savedValue.trim().toLowerCase() === enteredValue.trim().toLowerCase();
});

const getSavedAddressUrl = (form) => {
  const url = new URL(window.location.href);
  const sectionId = form.closest('.shopify-section')?.id.replace('shopify-section-', '');
  if (sectionId) url.searchParams.set('section_id', sectionId);
  return url.toString();
}

// Shopify normalizes saved addresses (E.164 phone, country display name), so mirror the option it renders after reload
const fetchSavedAddressOption = (form, formData) => {
  const knownIds = new Set(Array.from(document.querySelectorAll('.address-select__select option[data-address-id]')).map(option => option.getAttribute('data-address-id')));
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), savedAddressTimeout);

  return fetch(getSavedAddressUrl(form), { signal: controller.signal })
    .then(response => response.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const candidates = new Map();

      doc.querySelectorAll('.address-select__select option[data-address-id]').forEach((option) => {
        const id = option.getAttribute('data-address-id');
        if (id && !knownIds.has(id) && isEnteredAddressOption(option, formData)) candidates.set(id, option);
      });

      return candidates.size === 1 ? candidates.values().next().value : null;
    })
    .finally(() => clearTimeout(timeoutId));
}

const savedAddressFormData = (option, sourceFormData) => {
  const formData = new FormData();
  sourceFormData.forEach((value, key) => formData.append(key, value));
  Object.entries(savedAddressFields).forEach(([field, attr]) => {
    formData.set(`address[${field}]`, option.getAttribute(`data-address-${attr}`) || '');
  });
  return formData;
}

const savingForms = new WeakSet();

const sendAddressForm = (thisForm, button, billingAddress = false) => {
  if (savingForms.has(thisForm)) return;
  savingForms.add(thisForm);

  const formData = new FormData(thisForm);
  const formGroupIndex = thisForm?.closest('.shipping-section__delivery-group')?.getAttribute('data-delivery-index');
  const edit = thisForm.hasAttribute('data-default-address') ? thisForm.getAttribute('data-default-address') : undefined;
  const itemKey = thisForm.getAttribute('data-item-popup-key');
  const provinceSelect = document.querySelector('.cart-address-form country-selector .form-control:last-child');
  let addressId = formGroupIndex && window.multiCart.groups[formGroupIndex]?.address?.id ? window.multiCart.groups[formGroupIndex].address.id : null;

  if (window.customerAddresses.length) {
    for (let i = 0; i < window.customerAddresses.length; i++) {
      const address = window.customerAddresses[i];
      const formattedAddress = window.formatAddress(address);
      if (formattedAddress === edit) {
        addressId = address.id;
        break;
      }
    }
  }

  const isCustomerForm = thisForm.hasAttribute('data-for-customer') && !billingAddress;

  const finish = (saveToLocalStorage, savedOption = null) => {
    try {
      if (edit) {
        window.addNewAddress(formData, itemKey, saveToLocalStorage, edit, formGroupIndex);
      } else {
        const addressData = savedOption ? savedAddressFormData(savedOption, formData) : formData;
        window.addNewAddress(addressData, itemKey, saveToLocalStorage, undefined, undefined, savedOption?.getAttribute('data-address-id'));
        thisForm.reset();
        if (provinceSelect) provinceSelect.setAttribute('hidden', true);
      }
    } finally {
      button.removeAttribute('aria-busy');
      savingForms.delete(thisForm);
    }
  };

  const fallbackToLocal = (error) => {
    console.warn('Address was not saved to the customer account, keeping it in the cart only:', error);
    finish(true);
  };

  if (isCustomerForm && !edit) {
    postToCustomerAccount(thisForm.action, formData)
    .then(() => {
      fetchSavedAddressOption(thisForm, formData).then(
        (savedOption) => finish(false, savedOption),
        (error) => {
          console.warn('Could not load the saved customer address:', error);
          finish(false);
        }
      );
    }, fallbackToLocal);
  } else if (isCustomerForm && edit && addressId) {
    postToCustomerAccount('/account/addresses/' + addressId, formData)
    .then(() => {
      fetch('/cart?view=shipping-step')
      .then(response => response.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector('#customer_addresses');
        const currentSection = document.querySelector('#customer_addresses');

        if (newSection && currentSection) {
          currentSection.innerHTML = newSection.innerHTML;
          window.customerAddresses = JSON.parse(currentSection.innerHTML);
        }

        finish(false);
        window.slideToggleContent(thisForm);
      })
      .catch(error => {
        console.error('Error reloading multishipping section:', error);
        location.reload();
      });
    }, fallbackToLocal);
  } else if (billingAddress) {
    const customerSeriveBtns = document.querySelectorAll('.customer-service-btn, #to-checkout');
    if (customerSeriveBtns.length) {
      customerSeriveBtns.forEach(el => {
        el.setAttribute('aria-busy', 'true');
      })
    }
    Promise.resolve()
    .then(() => window.getDraftCheckout(button, true))
    .catch((error) => console.error(error))
    .finally(() => savingForms.delete(thisForm));
  } else {
    finish(true);
  }
}
/********************* END SEND ADDRESS FORM *********************/


/********************* CHECK MARKET ADDRESSES *********************/
window.checkMarketAddresses = () => {
  const currentMarket = window.cartSettings.localization;
  let marketLogicStatus = window.cartSettings.market_logic_status;
  const customerServiceExclude = window.cartSettings.customer_service_exclude;
  const usErrorHtml = window.cartSettings.us_error_message ? window.cartSettings.us_error_message : null;
  const ukErrorHtml = window.cartSettings.us_error_message ? window.cartSettings.uk_error_message : null;
  const checkoutBtn = document.querySelector('.multi-cart button[name="checkout"]') || document.getElementById('to-checkout') || null;
  const customerServiceBtn = document.getElementById('customer_service_submit') || null;
  const errorMsgEl = document.querySelector('.market-error-message');
  let errorMsg = `<div class='market-error-message'><p>The selected address is not valid for your location.</p></div>`;
  let globalError = false;

  if (customerServiceExclude && window.csbGetCookie("customerService")) marketLogicStatus = false;

  if (currentMarket && marketLogicStatus && window.multiCart?.carts && window.multiCart.carts.length) {
    if (window.shippingStep) {
      for (let i = 0; i < window.multiCart.groups.length; i++) {
        let groupItemSelect = document.querySelector(`.shipping-section__delivery-group[data-delivery-index="${i}"] .select-selected`);
        const groupItem = window.multiCart.groups[i];
        const addressCountry = groupItem?.address?.country;
        let groupError = false;

        if (currentMarket === "united-kingdom" && addressCountry && addressCountry.trim().toLowerCase() !== "united kingdom") {
          if (usErrorHtml) errorMsg = `<div class='market-error-message'>${ukErrorHtml}</div>`;
          globalError = true;
          groupError = true;
        } else if (currentMarket !== "united-kingdom" && addressCountry && addressCountry == "United Kingdom") {
          if (usErrorHtml) errorMsg = `<div class='market-error-message'>${usErrorHtml}</div>`;
          globalError = true;
          groupError = true;
        }

        if (groupError && groupItemSelect) {
          groupItemSelect.classList.add('is-market-error');
        } else if (groupItemSelect) {
          groupItemSelect.classList.remove('is-market-error');
        }
      }
    } else {
      for (let i = 0; i < window.multiCart.carts.length; i++) {
        const lineItem = window.multiCart.carts[i];
        let lineItemSelect = document.querySelector(`.order-summary__line-item[data-item-key="${lineItem.item_id}"] .select-selected`);
        const addressCountry = lineItem?.address?.country;
        let lineError = false;

        if (currentMarket === "united-kingdom" && addressCountry && addressCountry.trim().toLowerCase() !== "united kingdom") {
          if (usErrorHtml) errorMsg = `<div class='market-error-message'>${ukErrorHtml}</div>`;
          globalError = true;
          lineError = true;
        } else if (currentMarket !== "united-kingdom" && addressCountry && addressCountry == "United Kingdom") {
          if (usErrorHtml) errorMsg = `<div class='market-error-message'>${usErrorHtml}</div>`;
          globalError = true;
          lineError = true;
        }

        if (lineError && lineItemSelect) {
          lineItemSelect.classList.add('is-market-error');
        } else if (lineItemSelect) {
          lineItemSelect.classList.remove('is-market-error');
        }
      }
    }
  }

  if (globalError) {
    localStorage.setItem('_csb-market-error', true);
    
    if (checkoutBtn) {
      const cartFormContainer = document.querySelector('.cart-order__recap .cart-form') || document.querySelector('.shipping-section__main-inner') || null;
      checkoutBtn.setAttribute('disabled', 'disabled');

      if (customerServiceBtn) customerServiceBtn.setAttribute('disabled', 'disabled');
      if (cartFormContainer && !errorMsgEl) {
        if (window.shippingStep) {
          setTimeout(() => {
            const newErrorMsgEl = document.querySelector('.market-error-message');
            if (!newErrorMsgEl) {
              cartFormContainer.insertAdjacentHTML("beforeend", errorMsg)
            }
          },300);
        } else {
          cartFormContainer.insertAdjacentHTML("beforeend", errorMsg);
        }
      }
    }

    const haederHeight = document.querySelector('.shopify-section--header') ? document.querySelector('.shopify-section--header').offsetHeight : 0;
    const scrollElement = document.getElementById('cart-order__recap') || document.getElementById('to-checkout') || null;

    if (scrollElement) {
      const scrollPosition = scrollElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = scrollPosition - haederHeight - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  } else {
    localStorage.removeItem('_csb-market-error');
    if (checkoutBtn) checkoutBtn.removeAttribute('disabled');
    if (errorMsgEl) errorMsgEl.remove();
    if (customerServiceBtn) customerServiceBtn.removeAttribute('disabled');
  }
}
/********************* END CHECK MARKET ADDRESSES  *********************/


/********************* CLICK EVENTS *********************/
document.addEventListener('click', (e) => {
  if (!e.target) return;

  /********************* all address select close *********************/
  const activeSelect = document.querySelectorAll('.select-arrow-active');
  
  if (!e.target.closest('.address-select') && !e.target.closest('.select-search') && !e.target.classList.contains('select-search') && activeSelect.length) {
    activeSelect.forEach(el => {
      el.classList.remove('select-arrow-active');
      el.nextElementSibling?.classList.add('search-hide');
      el.nextElementSibling?.nextElementSibling?.classList.add('select-hide');
    })
  }
  /********************* end all address select close *********************/


  /********************* add new address *********************/
  if ((e.target.closest('.cart-address-form') && e.target.hasAttribute('data-address-submit')) 
    || (e.target.closest('.shipping-section__delivery-group') && e.target.hasAttribute('data-address-edit'))) {
    e.preventDefault();

    let formIsValid = true;
    const thisForm = e.target.closest('.form');
    const billingAddress = e.target.hasAttribute('data-billing-address-submit') ? true : false;
        
    if (thisForm) {
      const inputs = thisForm.querySelectorAll('input[required], select[required]');
      thisForm.querySelectorAll('.error-message')?.forEach(el => el.remove());
      inputs.forEach(input => input.classList.remove('error-input'));
      
      inputs.forEach(input => {
        if (!input.value.trim() && !input.hasAttribute('disabled')) {
          formIsValid = false;
          input.classList.add('error-input');
          const errorMessage = document.createElement('div');
          errorMessage.classList.add('error-message');
          errorMessage.innerText = 'This field is required';
          input.parentNode.appendChild(errorMessage);
          input.addEventListener('input', function() {
          if (input.value.trim()) {
            input.classList.remove('error-input');
            const error = input.parentNode.querySelector('.error-message');
            if (error) {
              error.remove();
            }
          }
          }, { once: true });
        }

        if (input.getAttribute('name') === "address[phone]" && !window.validatePhoneNumber(input)) {
          formIsValid = false;
        }
      });

      if (formIsValid) {
        e.target.classList.add('is-loading');
        e.target.setAttribute('aria-busy', 'true');

        if (window.cartSettings.loqate_key && window.cartSettings.loqate_validation_endpoint) {
          locateValidation(thisForm, e.target, billingAddress);
        } else {
          sendAddressForm(thisForm, e.target, billingAddress);
        }
      }
    }
  }
  /********************* end add new address *********************/


  /********************* close address edit *********************/
  if (e.target.hasAttribute('data-edit-close')) {
    const parentForm = e.target.closest('.form--edit');
    const parentBtn = e.target.closest('.address-select')?.querySelector('.address-edit');

    if (parentForm) window.slideToggleContent(parentForm);
    if (parentBtn) parentBtn.classList.remove('is-active');
  }
  /********************* end close address edit *********************/
});
/********************* END CLICK EVENTS *********************/


/********************* INPUT EVENTS *********************/
document.addEventListener('input', (e) => {
  if (!e.target) return;

  if (e.target.hasAttribute('name') && e.target.getAttribute('name') === "address[phone]") {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, '');
    e.target.value = inputValue;
  }
});
/********************* END INPUT EVENTS *********************/


/********************* ADDRESS GROUPING *********************/
let groupAnimation = false;
let previousGroupState = null;

window.addressGrouping = (multicart) => {
  const lineItems = document.querySelectorAll('.order-summary__line-item');
  const groups = multicart.groups.reverse();
  const groupTitles = document.querySelectorAll('.order-summary__delivery-group');
  const groupCount = groups.length || 1;
  const newGroupState = {};

  lineItems.forEach(item => {
    const itemKey = item.getAttribute('data-item-key');
    const groupIndex = groups.findIndex(group => group.items.find(i => i.item.key === itemKey));

    const newGroupNumber = groupIndex !== -1 ? groupIndex + 1 : groupCount + 1;
    newGroupState[itemKey] = newGroupNumber;
    item.setAttribute('data-group', newGroupNumber);
  });

  if (!groupTitles.length) {
    groupAnimation = false;
  }

  const hasChanges = !previousGroupState || 
    Object.keys(newGroupState).length !== Object.keys(previousGroupState).length ||
    Object.keys(newGroupState).some(key => newGroupState[key] !== previousGroupState[key]) ||
    groupTitles.length !== groupCount;

  previousGroupState = { ...newGroupState };
  if (!hasChanges) {
    return;
  }

  if (groupTitles.length) {
    if (window.cartSettings?.grouping_animation) {
      groupTitles.forEach(item => {
        item.classList.add('animation-header-hide');
      });

      setTimeout(() => {
        groupTitles.forEach(item => item.remove());
        reorganizeItemsByGroup(groupAnimation);
        groupAnimation = true;
      }, 400);
    } else {
      groupTitles.forEach(item => item.remove());
      reorganizeItemsByGroup(groupAnimation);
      groupAnimation = true;
    }
  } else {
    reorganizeItemsByGroup(groupAnimation);
    groupAnimation = true;
  }
  
  function reorganizeItemsByGroup(withAnimation = false) {
    const container = document.querySelector('tbody.order-summary__body');
    if (!container) return;
    
    const itemsWithGroups = Array.from(lineItems).filter(item => 
      item.hasAttribute('data-group')
    ).sort((a, b) => {
      const groupA = parseInt(a.getAttribute('data-group'));
      const groupB = parseInt(b.getAttribute('data-group'));
      return groupA - groupB;
    });
    
    if (withAnimation && window.cartSettings?.grouping_animation) {
      reorganizeWithAnimation(itemsWithGroups, container);
    } else {
      reorganizeWithoutAnimation(itemsWithGroups, container);
    }
  }
  
  function reorganizeWithoutAnimation(sortedItems, container) {
    sortedItems.forEach(item => {
      container.appendChild(item);
    });
    createNewHeaders(container);
  }
  
  async function reorganizeWithAnimation(sortedItems, container) {
    if (!document.getElementById('group-animation-styles')) {
      const style = document.createElement('style');
      style.id = 'group-animation-styles';
      style.textContent = `
        .item-flip-moving {
          transition: transform 0.45s cubic-bezier(0.4, 0.0, 0.2, 1);
          z-index: 10;
        }
        
        .item-flip-highlight {
          box-shadow: 0 8px 25px rgba(0,0,0,0.2);
          transform: scale(1.02);
          z-index: 11;
        }
        
        .container-reorganizing {
          position: relative;
        }
      `;
      document.head.appendChild(style);
    }

    container.classList.add('container-reorganizing');
    
    const initialPositions = new Map();
    sortedItems.forEach(item => {
      const rect = item.getBoundingClientRect();
      initialPositions.set(item, {
        top: rect.top,
        left: rect.left
      });
    });
    
    sortedItems.forEach(item => {
      container.appendChild(item);
    });
    
    const animations = [];
    sortedItems.forEach(item => {
      const rect = item.getBoundingClientRect();
      const initialPos = initialPositions.get(item);
      const deltaX = initialPos.left - rect.left;
      const deltaY = initialPos.top - rect.top;
      const hasMovement = Math.abs(deltaX) > 1 || Math.abs(deltaY) > 1;
      
      if (hasMovement) {
        item.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
        item.style.transition = 'none';
        
        animations.push({ item, deltaX, deltaY });
      }
    });
    
    container.offsetHeight;
    
    if (animations.length === 0) {
      createNewHeaders(container, () => {
        container.classList.remove('container-reorganizing');
      });
      return;
    }
    
    animations.forEach(({ item, deltaX, deltaY }, index) => {
      const delay = index * 75;
      
      setTimeout(() => {
        item.classList.add('item-flip-highlight');
        
        item.style.transition = 'transform 0.45s cubic-bezier(0.4, 0.0, 0.2, 1), box-shadow 0.45s ease-out';
        item.style.transform = 'translate(0, 0)';
        
        setTimeout(() => {
          item.classList.remove('item-flip-highlight');
          item.style.transition = '';
          item.style.transform = '';
          
          if (index === animations.length - 1) {
            setTimeout(() => {
              createNewHeaders(container, () => {
                container.classList.remove('container-reorganizing');
              });
            }, 75);
          }
        }, 450);
        
      }, delay);
    });
  }
  
  function createNewHeaders(container, onComplete = null) {
    const itemsWithGroups = Array.from(container.querySelectorAll('[data-group]'))
      .sort((a, b) => {
        const groupA = parseInt(a.getAttribute('data-group'));
        const groupB = parseInt(b.getAttribute('data-group'));
        return groupA - groupB;
      });
    
    if (itemsWithGroups.length === 0) {
      if (onComplete) onComplete();
      return;
    }
    
    const groupedItems = {};
    itemsWithGroups.forEach(item => {
      const groupNumber = parseInt(item.getAttribute('data-group'));
      if (!groupedItems[groupNumber]) {
        groupedItems[groupNumber] = [];
      }
      groupedItems[groupNumber].push(item);
    });

    const neededGroups = Object.keys(groupedItems).filter(groupNum => groupedItems[groupNum].length > 0);

    if (neededGroups.length === 0) {
      if (onComplete) onComplete();
      return;
    }

    const existingHeaders = container.querySelectorAll('.order-summary__delivery-group');
    existingHeaders.forEach(header => header.remove());

    let headersProcessed = 0;
    const totalHeaders = neededGroups.length;

    neededGroups
      .sort((a, b) => parseInt(a) - parseInt(b))
      .forEach((groupNumber, index) => {
        const groupNum = parseInt(groupNumber);
        const firstItemInGroup = groupedItems[groupNumber][0];
        if (!firstItemInGroup) return;
        
        const existingHeader = container.querySelector(`tr.order-summary__delivery-group[data-delivery-index="${groupNum}"]`);
        if (existingHeader) {
          headersProcessed++;
          if (headersProcessed === totalHeaders && onComplete) {
            if (groupAnimation && window.cartSettings?.grouping_animation) {
              setTimeout(onComplete, 150);
            } else {
              onComplete();
            }
          }
          return;
        }
        
        const groupHeader = document.createElement('tr');
        groupHeader.className = 'order-summary__delivery-group';
        groupHeader.setAttribute('data-delivery-index', groupNum);
        groupHeader.setAttribute('data-addr-value', '');
        
        groupHeader.innerHTML = `
          <th colspan="4">
            <div class="delivery-header">
              <h3 class="h3">Ship To ${groupNum}</h3>
            </div>
          </th>
        `;
        
        if (groupAnimation && window.cartSettings?.grouping_animation) {
          groupHeader.classList.add('animation-header-hide');
          container.insertBefore(groupHeader, firstItemInGroup);
          
          setTimeout(() => {
            groupHeader.classList.remove('animation-header-hide');
            headersProcessed++;
            
            if (headersProcessed === totalHeaders && onComplete) {
              setTimeout(onComplete, 150);
            }
          }, index * 100 + 100);
        } else {
          container.insertBefore(groupHeader, firstItemInGroup);
          headersProcessed++;
          
          if (headersProcessed === totalHeaders && onComplete) {
            onComplete();
          }
        }
      });
  }
}
/********************* END ADDRESS GROUPING *********************/